import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Commesse from "@/pages/Commesse";
import CommessaDetail from "@/pages/CommessaDetail";
import Personale from "@/pages/Personale";
import Notifiche from "@/pages/Notifiche";
import Audit from "@/pages/Audit";
import Toth from "@/pages/Toth";
import Admin from "@/pages/Admin";
import Profilo from "@/pages/Profilo";
import Mappe from "@/pages/Mappe";
import Criticita from "@/pages/Criticita";
import CriticitaDetail from "@/pages/CriticitaDetail";
import Ispezioni, { IspezioneDetail } from "@/pages/Ispezioni";
import Mezzi from "@/pages/Mezzi";
import MezzoDetail from "@/pages/MezzoDetail";
import Documenti from "@/pages/Documenti";
import DocumentoDetail from "@/pages/DocumentoDetail";
import Obblighi from "@/pages/Obblighi";
import Ricorrenze from "@/pages/Ricorrenze";

const Protected = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-muted-foreground" data-testid="auth-loading">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user) return <Navigate to="/" replace />;
  return <Login />;
};

function App() {
  useEffect(() => {
    if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route index element={<Home />} />
            <Route path="ordini" element={<Orders />} />
            <Route path="ordini/:id" element={<OrderDetail />} />
            <Route path="ricorrenze" element={<Protected roles={["ceo", "amministrazione", "responsabile"]}><Ricorrenze /></Protected>} />
            <Route path="commesse" element={<Commesse />} />
            <Route path="commesse/:id" element={<CommessaDetail />} />
            <Route path="personale" element={<Protected roles={["ceo", "amministrazione", "responsabile"]}><Personale /></Protected>} />
            <Route path="notifiche" element={<Notifiche />} />
            <Route path="audit" element={<Protected roles={["ceo", "amministrazione"]}><Audit /></Protected>} />
            <Route path="toth" element={<Protected roles={["ceo", "amministrazione"]}><Toth /></Protected>} />
            <Route path="admin" element={<Protected roles={["ceo", "amministrazione"]}><Admin /></Protected>} />
            <Route path="profilo" element={<Profilo />} />
            <Route path="mappe" element={<Mappe />} />
            <Route path="mappe/:cimiteroId" element={<Mappe />} />
            <Route path="criticita" element={<Criticita />} />
            <Route path="criticita/:id" element={<CriticitaDetail />} />
            <Route path="ispezioni" element={<Ispezioni />} />
            <Route path="ispezioni/:id" element={<IspezioneDetail />} />
            <Route path="mezzi" element={<Mezzi />} />
            <Route path="mezzi/:id" element={<MezzoDetail />} />
            <Route path="documenti" element={<Protected roles={["ceo", "amministrazione", "responsabile"]}><Documenti /></Protected>} />
            <Route path="documenti/:id" element={<Protected roles={["ceo", "amministrazione", "responsabile"]}><DocumentoDetail /></Protected>} />
            <Route path="obblighi" element={<Protected roles={["ceo", "amministrazione", "responsabile"]}><Obblighi /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
